import { Link } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'
import { cn } from '@/utils/cn'

export default function VoiceSectionPage({ title, description, children, className }) {
  return (
    <div className={cn('w-full min-w-0 space-y-6', className)}>
      <div>
        <Link
          to="/"
          className="inline-flex items-center gap-1 text-sm font-medium text-muted-foreground hover:text-foreground touch-manipulation min-h-[44px] sm:min-h-0"
        >
          <ChevronLeft className="h-4 w-4 shrink-0" aria-hidden />
          Início
        </Link>
        <h1 className="mt-3 text-2xl font-bold tracking-tight sm:text-3xl">{title}</h1>
        {description ? (
          <p className="mt-2 max-w-3xl text-sm text-muted-foreground sm:text-base">{description}</p>
        ) : null}
      </div>
      <div className="w-full min-w-0">{children}</div>
    </div>
  )
}
